import React from "react";
import { Form } from "antd";
import Button from "@/common/elements/Button";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import {
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
} from "@/common/styles";
import useDialog from "@/hooks/useDialog";
import { isNonEmptyVariable } from "@/util/common_function";
import { useSelector } from "react-redux";

const JailIncidenSanctionInformation = ({
  involvementsForm,
  sanctionOptionsAll,
  isFieldEnable,
}) => {
  const { showDialog } = useDialog();
  const sanctionOptions = sanctionOptionsAll.filter((_, index) => index !== 0);
  const onHandleViewComment = () => {
    const comment =
      involvementsForm?.getFieldValue("sanctionComments") ||
      "No comment available";
    showDialog("info", {
      content: comment,
      confirmButtonText: "Ok",
    });
  };

  return (
    <>
      <StyledSectionHeading marginTop="20px">
        <span>Sanction Information</span>
      </StyledSectionHeading>

      <>
        <StyledGridRow gutter={16}>
          <Form.List name="jailIncidentsInvolvedInmateSanctions">
            {(fields, { add, remove }) => (
              <>
                {sanctionOptions.map((option, index) => {
                  // check if mappingData already has this violation
                  const mappingData =
                    involvementsForm?.getFieldValue(
                      "jailIncidentsInvolvedInmateSanctions",
                    ) || [];

                  const jailIncidentsInvolvedInmateId =
                    isNonEmptyVariable(mappingData) && mappingData?.length
                      ? mappingData?.[0]?.jailIncidentsInvolvedInmateId
                      : null;

                  const existing = mappingData?.find(
                    (m) => m.jailIncidentsSanctionsId === option.value,
                  );

                  const isChecked = !!existing;

                  return (
                    <StyledGridCol lg={8} key={option.value}>
                      <Form.Item valuePropName="checked">
                        <Checkbox
                          checked={isChecked}
                          onChange={(e) => {
                            if (e.target.checked) {
                              // add new object into array
                              add({
                                jailIncidentsInvolvedInmateId:
                                  jailIncidentsInvolvedInmateId, // or dynamic
                                jailIncidentsSanctionsId: option.value,
                                jailIncidentsInvolvedInmateSanctionId: null,
                              });
                            } else {
                              // remove existing object from array
                              const idx = fields?.findIndex(
                                (f) =>
                                  involvementsForm?.getFieldValue([
                                    "jailIncidentsInvolvedInmateSanctions",
                                    f.name,
                                    "jailIncidentsSanctionsId",
                                  ]) === option.value,
                              );
                              if (idx > -1) remove(idx);
                            }
                          }}
                          disabled={!isFieldEnable}
                        >
                          <p
                            style={{
                              color: isFieldEnable ? "#000" : "#999",
                            }}
                          >
                            {option.label}
                          </p>
                        </Checkbox>
                      </Form.Item>
                    </StyledGridCol>
                  );
                })}
              </>
            )}
          </Form.List>
        </StyledGridRow>

        <StyledGridRow gutter={16}>
          <StyledGridCol lg={24} marginTop="12px">
            <FormItem label="Comments" name="sanctionComments">
              <TextField
                inputType="textarea"
                rows="3"
                disabled={!isFieldEnable}
              />
            </FormItem>
            <Button
              type="primary"
              color="primary"
              onClick={onHandleViewComment}
            >
              View Comments
            </Button>
          </StyledGridCol>
        </StyledGridRow>
      </>
    </>
  );
};

export default JailIncidenSanctionInformation;
